var r=.2126,t=.7152,n=.0722,u=1/12.92;function a(r){return Math.pow((r+.055)/1.055,2.4)}export default function(e){var o=e[0]/255,f=e[1]/255,c=e[2]/255,i=o<=.03928?o*u:a(o),p=f<=.03928?f*u:a(f),v=c<=.03928?c*u:a(c);return i*r+p*t+v*n};
//# sourceMappingURL=index.m.js.map
